import { http } from '../../core/services/http';
import transformLoadServiceTypes from './transformLoadServiceTypes';

const loadServiceTypes = (vehicleTypeId?: number) =>
  http
    .get(`services/serviceTypesAndSubTypes${vehicleTypeId ? `?vehicleTypeId=${vehicleTypeId}` : ''}`)
    .then(response => transformLoadServiceTypes(response.data));

export default loadServiceTypes;
